(function(){
  'use strict';

  var TYPES = [
    { id:0, cls:'gem-amethyst',   name:'Amethyst' },
    { id:1, cls:'gem-quartz',     name:'Clear Quartz' },
    { id:2, cls:'gem-tigerseye',  name:"Tiger's Eye" },
    { id:3, cls:'gem-snowflake',  name:'Snowflake Obsidian' },
    { id:4, cls:'gem-rosequartz', name:'Rose Quartz' },
    { id:5, cls:'gem-labradorite', name:'Labradorite' }
  ];
  var TYPE_CLASSES = TYPES.map(function(t){ return t.cls; });

  // 5 levels, 6 crystals -- a tighter, friendlier curve. Type-count ramps
  // up to the full set of 6 by level 3, then levels 4-5 lean on tighter
  // move budgets and higher targets rather than adding new variety.
  var LEVELS = [
    { types:4, target:777,  moves:20, tag:"Sorting today's delivery",             tools:null },
    { types:5, target:999,  moves:22, tag:'Regulars start rolling in',            tools:null },
    { types:6, target:1111, moves:23, tag:'A group of tourists stampede the shelves',    tools:{ shuffle:2, mine:2, rowclear:1 } },
    { types:6, target:1234, moves:24, tag:'A collector wants the rare stock',      tools:{ shuffle:2, mine:2, rowclear:2 } },
    { types:6, target:2222, moves:25, tag:'Closing time: sell out or stay all night', tools:{ shuffle:3, mine:2, rowclear:2 } }
  ];

  var COMBO_CALLOUTS = ['', '', 'Awesome!', 'Sweet match!', 'Crystal combo!', 'On fire!', 'Unstoppable!', 'LEGENDARY!'];

  var SIZE = 8;
  var CELL_COUNT = SIZE * SIZE;
  var ANIM_CLEAR_MS = 160;
  var ANIM_DROP_MS = 200;

  var grid = new Int8Array(CELL_COUNT);
  var levelIndex = 0;
  var score = 0;
  var movesLeft = 0;
  var selected = -1;
  var busy = false;
  var activeTool = null; // null | 'mine' | 'rowclear'
  var charges = { shuffle:0, mine:0, rowclear:0 };

  var cellEls = new Array(CELL_COUNT);
  var gemEls = new Array(CELL_COUNT);
  var renderedType = new Int8Array(CELL_COUNT).fill(-2);

  var boardEl, levelValue, scoreValue, movesValue, targetLabel, progressFill,
      levelTagline, levelDotsEl, modalBackdrop, modalTitle, modalBody,
      modalEyebrow, modalBtn, restartBtn, toolbarEl, toolHintEl,
      toolShuffleBtn, toolMineBtn, toolRowBtn, shuffleCountEl, mineCountEl, rowCountEl,
      couponPanel, couponCopyBtn, comboCalloutEl, confettiLayerEl, shelfEl,
      appEl, couponCodeEl;

  function idx(r,c){ return r*SIZE+c; }
  function randType(n){ return (Math.random()*n)|0; }

  function wouldMatchAt(g, r, c, t){
    if(c>=2 && g[idx(r,c-1)]===t && g[idx(r,c-2)]===t) return true;
    if(r>=2 && g[idx(r-1,c)]===t && g[idx(r-2,c)]===t) return true;
    return false;
  }

  function buildGrid(n){
    var g = new Int8Array(CELL_COUNT);
    for(var r=0;r<SIZE;r++){
      for(var c=0;c<SIZE;c++){
        var t, guard=0;
        do{ t = randType(n); guard++; } while(wouldMatchAt(g,r,c,t) && guard<40);
        g[idx(r,c)] = t;
      }
    }
    return g;
  }

  function findMatches(g){
    var toClear = new Set();
    var r, c, k, runStart, runLen, cur, prev;
    for(r=0;r<SIZE;r++){
      runStart=0;
      for(c=1;c<=SIZE;c++){
        cur = c<SIZE ? g[idx(r,c)] : -99;
        prev = g[idx(r,runStart)];
        if(c<SIZE && cur===prev) continue;
        runLen = c - runStart;
        if(runLen>=3) for(k=runStart;k<c;k++) toClear.add(idx(r,k));
        runStart = c;
      }
    }
    for(c=0;c<SIZE;c++){
      runStart=0;
      for(r=1;r<=SIZE;r++){
        cur = r<SIZE ? g[idx(r,c)] : -99;
        prev = g[idx(runStart,c)];
        if(r<SIZE && cur===prev) continue;
        runLen = r - runStart;
        if(runLen>=3) for(k=runStart;k<r;k++) toClear.add(idx(k,c));
        runStart = r;
      }
    }
    return toClear;
  }

  function swapCells(g,a,b){ var tmp=g[a]; g[a]=g[b]; g[b]=tmp; }

  function hasPossibleMove(g){
    for(var r=0;r<SIZE;r++){
      for(var c=0;c<SIZE;c++){
        if(c<SIZE-1){
          swapCells(g, idx(r,c), idx(r,c+1));
          var m1 = findMatches(g).size>0;
          swapCells(g, idx(r,c), idx(r,c+1));
          if(m1) return true;
        }
        if(r<SIZE-1){
          swapCells(g, idx(r,c), idx(r+1,c));
          var m2 = findMatches(g).size>0;
          swapCells(g, idx(r,c), idx(r+1,c));
          if(m2) return true;
        }
      }
    }
    return false;
  }

  function buildSolvableGrid(n){
    var g, attempts=0;
    do{ g = buildGrid(n); attempts++; } while(!hasPossibleMove(g) && attempts<60);
    return g;
  }

  function applyGravity(g){
    var lvl = LEVELS[levelIndex];
    for(var c=0;c<SIZE;c++){
      var col = [];
      for(var r=0;r<SIZE;r++){ var v=g[idx(r,c)]; if(v!==-1) col.push(v); }
      var missing = SIZE - col.length;
      var write = 0;
      for(var i=0;i<missing;i++){ g[idx(write,c)] = randType(lvl.types); write++; }
      for(var j=0;j<col.length;j++){ g[idx(write,c)] = col[j]; write++; }
    }
  }

  // --- DOM setup (once) -------------------------------------------------

  function buildBoardDom(){
    var frag = document.createDocumentFragment();
    for(var i=0;i<CELL_COUNT;i++){
      var cell = document.createElement('div');
      cell.className = 'cell';
      cell.dataset.index = i;
      var gem = document.createElement('div');
      gem.className = 'gem';
      cell.appendChild(gem);
      frag.appendChild(cell);
      cellEls[i] = cell;
      gemEls[i] = gem;
    }
    boardEl.appendChild(frag);
    boardEl.addEventListener('click', function(e){
      var cell = e.target.closest('.cell');
      if(!cell) return;
      onCellClick(parseInt(cell.dataset.index,10));
    });
  }

  function render(clearingSet){
    for(var i=0;i<CELL_COUNT;i++){
      var t = grid[i];
      var gemEl = gemEls[i];

      if(clearingSet && clearingSet.has(i)){
        gemEl.classList.add('clearing');
        renderedType[i] = -2; // invalidate so the post-gravity repaint always fires,
                               // even if the refill happens to be the same crystal type
      } else if(t !== renderedType[i]){
        renderedType[i] = t;
        gemEl.classList.remove('clearing');
        if(t>=0){
          gemEl.className = 'gem drop ' + TYPE_CLASSES[t];
          gemEl.style.visibility = 'visible';
        } else {
          gemEl.className = 'gem';
          gemEl.style.visibility = 'hidden';
        }
      }
      cellEls[i].classList.toggle('selected', selected===i);
    }
  }

  // --- Juice: sparkles, combo callouts, shelf wobble, confetti ----------

  function spawnSparkles(cellEl){
    for(var k=0;k<4;k++){
      var s = document.createElement('span');
      s.className = 'spark';
      var angle = Math.random()*Math.PI*2;
      var dist = 16 + Math.random()*14;
      s.style.setProperty('--dx', (Math.cos(angle)*dist)+'px');
      s.style.setProperty('--dy', (Math.sin(angle)*dist)+'px');
      cellEl.appendChild(s);
      (function(node){ setTimeout(function(){ node.remove(); }, 460); })(s);
    }
  }

  function showComboCallout(combo){
    var text = COMBO_CALLOUTS[Math.min(combo, COMBO_CALLOUTS.length-1)];
    if(!text) return;
    comboCalloutEl.textContent = text;
    comboCalloutEl.classList.remove('show');
    void comboCalloutEl.offsetWidth; // restart animation
    comboCalloutEl.classList.add('show');
  }

  function wobbleShelf(){
    shelfEl.classList.remove('wobble');
    void shelfEl.offsetWidth;
    shelfEl.classList.add('wobble');
  }

  var CONFETTI_COLORS = ['#B79ADB','#F5CE6B','#D9A44C','#5469a2','#8c578f','#7FE0C9','#B79A7C'];
  function launchConfetti(){
    for(var i=0;i<40;i++){
      var piece = document.createElement('div');
      piece.className = 'confetti-piece';
      piece.style.left = (Math.random()*100)+'vw';
      piece.style.background = CONFETTI_COLORS[(Math.random()*CONFETTI_COLORS.length)|0];
      piece.style.animationDuration = (2.2 + Math.random()*1.4)+'s';
      piece.style.animationDelay = (Math.random()*0.6)+'s';
      confettiLayerEl.appendChild(piece);
      (function(node){ setTimeout(function(){ node.remove(); }, 4200); })(piece);
    }
  }

  // --- HUD ---------------------------------------------------------------

  function popValue(el){
    el.classList.remove('pop');
    void el.offsetWidth;
    el.classList.add('pop');
    setTimeout(function(){ el.classList.remove('pop'); }, 260);
  }

  function updateHUD(scoreChanged){
    var lvl = LEVELS[levelIndex];
    levelValue.textContent = (levelIndex+1) + ' / ' + LEVELS.length;
    scoreValue.textContent = score;
    movesValue.textContent = movesLeft;
    targetLabel.textContent = 'Goal: ' + lvl.target;
    progressFill.style.width = Math.min(100, Math.round((score/lvl.target)*100)) + '%';
    levelTagline.textContent = lvl.tag;
    if(scoreChanged) popValue(scoreValue);

    for(var i=0;i<LEVELS.length;i++){
      var dot = levelDotsEl.children[i];
      dot.classList.toggle('done', i<levelIndex);
      dot.classList.toggle('current', i===levelIndex);
    }
    updateToolbar();
  }

  function buildLevelDots(){
    levelDotsEl.innerHTML='';
    var frag = document.createDocumentFragment();
    for(var i=0;i<LEVELS.length;i++){
      var dot = document.createElement('div');
      dot.className='level-dot';
      frag.appendChild(dot);
    }
    levelDotsEl.appendChild(frag);
  }

  function updateToolbar(){
    var lvl = LEVELS[levelIndex];
    if(!lvl.tools){
      toolbarEl.style.display='none';
      toolHintEl.textContent='';
      return;
    }
    toolbarEl.style.display='flex';
    shuffleCountEl.textContent = charges.shuffle;
    mineCountEl.textContent = charges.mine;
    rowCountEl.textContent = charges.rowclear;

    toolShuffleBtn.classList.toggle('disabled', charges.shuffle<=0);
    toolMineBtn.classList.toggle('disabled', charges.mine<=0);
    toolRowBtn.classList.toggle('disabled', charges.rowclear<=0);
    toolMineBtn.classList.toggle('active', activeTool==='mine');
    toolRowBtn.classList.toggle('active', activeTool==='rowclear');

    toolHintEl.textContent =
      activeTool==='mine' ? 'Tap a crystal to mine it away.' :
      activeTool==='rowclear' ? 'Tap a crystal to sweep its whole row.' : '';
  }

  // --- Game flow -----------------------------------------------------------

  function startLevel(i){
    levelIndex = i;
    var lvl = LEVELS[levelIndex];
    score = 0;
    movesLeft = lvl.moves;
    selected = -1;
    activeTool = null;
    busy = false;
    charges = lvl.tools ? { shuffle:lvl.tools.shuffle, mine:lvl.tools.mine, rowclear:lvl.tools.rowclear } : { shuffle:0, mine:0, rowclear:0 };
    grid = buildSolvableGrid(lvl.types);
    renderedType.fill(-2);
    updateHUD(false);
    render();
  }

  function onCellClick(i){
    if(busy) return;

    if(activeTool==='mine'){ doMine(i); return; }
    if(activeTool==='rowclear'){ doRowClear(i); return; }

    if(selected===-1){ selected=i; render(); return; }
    if(selected===i){ selected=-1; render(); return; }

    var r1=(selected/SIZE)|0, c1=selected%SIZE;
    var r2=(i/SIZE)|0, c2=i%SIZE;
    if(Math.abs(r1-r2)+Math.abs(c1-c2)!==1){ selected=i; render(); return; }

    attemptSwap(selected, i);
  }

  function attemptSwap(a,b){
    busy = true;
    swapCells(grid,a,b);
    var matches = findMatches(grid);
    if(matches.size===0){
      swapCells(grid,a,b);
      selected = -1;
      cellEls[a].classList.add('shake');
      cellEls[b].classList.add('shake');
      setTimeout(function(){
        cellEls[a].classList.remove('shake');
        cellEls[b].classList.remove('shake');
        busy=false;
      }, 300);
      render();
      return;
    }
    selected = -1;
    movesLeft--;
    resolveMatches(1);
  }

  function doMine(i){
    if(charges.mine<=0 || busy) return;
    charges.mine--;
    activeTool = null;
    busy = true;
    score += 10;
    updateHUD(true);
    spawnSparkles(cellEls[i]);
    render(new Set([i]));
    setTimeout(function(){
      grid[i] = -1;
      applyGravity(grid);
      render();
      setTimeout(function(){ resolveMatches(1); }, ANIM_DROP_MS);
    }, ANIM_CLEAR_MS);
  }

  function doRowClear(i){
    if(charges.rowclear<=0 || busy) return;
    charges.rowclear--;
    activeTool = null;
    busy = true;
    var r = (i/SIZE)|0;
    var cleared = new Set();
    for(var c=0;c<SIZE;c++) cleared.add(idx(r,c));
    score += cleared.size * 12;
    updateHUD(true);
    cleared.forEach(function(ci){ spawnSparkles(cellEls[ci]); });
    wobbleShelf();
    render(cleared);
    setTimeout(function(){
      cleared.forEach(function(ci){ grid[ci] = -1; });
      applyGravity(grid);
      render();
      setTimeout(function(){ resolveMatches(1); }, ANIM_DROP_MS);
    }, ANIM_CLEAR_MS);
  }

  function doShuffle(){
    if(charges.shuffle<=0 || busy) return;
    charges.shuffle--;
    activeTool = null;
    selected = -1;
    grid = buildSolvableGrid(LEVELS[levelIndex].types);
    renderedType.fill(-2);
    updateHUD(false);
    render();
  }

  function resolveMatches(combo){
    var matches = findMatches(grid);
    if(matches.size===0){
      busy = false;
      updateHUD(false);
      checkEndConditions();
      return;
    }
    score += matches.size * 15 * combo;
    updateHUD(true);
    matches.forEach(function(i){ spawnSparkles(cellEls[i]); });
    if(combo>=2){ showComboCallout(combo); }
    if(combo>=3){ wobbleShelf(); }
    render(matches);
    setTimeout(function(){
      matches.forEach(function(i){ grid[i] = -1; });
      applyGravity(grid);
      render();
      setTimeout(function(){ resolveMatches(combo+1); }, ANIM_DROP_MS);
    }, ANIM_CLEAR_MS);
  }

  function checkEndConditions(){
    var lvl = LEVELS[levelIndex];
    if(score>=lvl.target){ showModal('win'); return; }
    if(movesLeft<=0){ showModal('lose'); return; }
    if(!hasPossibleMove(grid)){
      grid = buildSolvableGrid(lvl.types);
      renderedType.fill(-2);
      render();
    }
  }

  function showModal(kind){
    couponPanel.style.display = 'none';
    if(kind==='win'){
      var isLast = levelIndex === LEVELS.length-1;
      modalEyebrow.textContent = isLast ? 'Shop Complete' : 'Level Complete';
      modalTitle.textContent = isLast ? 'Every Case Sold!' : 'Display Sorted!';
      modalBody.textContent = isLast
        ? 'You cleared every level and moved the last crystal off the shelf.'
        : 'You hit the target with ' + movesLeft + ' move' + (movesLeft===1?'':'s') + ' to spare. The next shipment is trickier.';
      modalBtn.textContent = isLast ? 'Restart shop' : 'Next level';
      modalBtn.onclick = function(){ hideModal(); startLevel(isLast ? 0 : levelIndex+1); };
      if(isLast){
        couponPanel.style.display = 'block';
        launchConfetti();
      }
    } else {
      modalEyebrow.textContent = 'Out of Moves';
      modalTitle.textContent = 'Case Not Cleared';
      modalBody.textContent = 'You reached ' + score + ' of ' + LEVELS[levelIndex].target + '. Give this shelf another go.';
      modalBtn.textContent = 'Retry level';
      modalBtn.onclick = function(){ hideModal(); startLevel(levelIndex); };
    }
    modalBackdrop.classList.add('visible');
  }

  function hideModal(){ modalBackdrop.classList.remove('visible'); }

  function toggleTool(name, key){
    if(busy || charges[key]<=0) return;
    activeTool = (activeTool===name) ? null : name;
    selected = -1;
    updateToolbar();
    render();
  }

  function init(){
    appEl = document.getElementById('crystal-crush-app');
    if(!appEl){ return; }   // section isn't on this page
    boardEl = document.getElementById('board');
    levelValue = document.getElementById('levelValue');
    scoreValue = document.getElementById('scoreValue');
    movesValue = document.getElementById('movesValue');
    targetLabel = document.getElementById('targetLabel');
    progressFill = document.getElementById('progressFill');
    levelTagline = document.getElementById('levelTagline');
    levelDotsEl = document.getElementById('levelDots');
    modalBackdrop = document.getElementById('modalBackdrop');
    modalTitle = document.getElementById('modalTitle');
    modalBody = document.getElementById('modalBody');
    modalEyebrow = document.getElementById('modalEyebrow');
    modalBtn = document.getElementById('modalBtn');
    restartBtn = document.getElementById('restartBtn');
    toolbarEl = document.getElementById('toolbar');
    toolHintEl = document.getElementById('toolHint');
    toolShuffleBtn = document.getElementById('toolShuffle');
    toolMineBtn = document.getElementById('toolMine');
    toolRowBtn = document.getElementById('toolRow');
    shuffleCountEl = document.getElementById('shuffleCount');
    mineCountEl = document.getElementById('mineCount');
    rowCountEl = document.getElementById('rowCount');
    couponPanel = document.getElementById('couponPanel');
    couponCopyBtn = document.getElementById('couponCopyBtn');
    couponCodeEl = document.getElementById('couponCode');
    comboCalloutEl = document.getElementById('comboCallout');
    confettiLayerEl = document.getElementById('confettiLayer');
    shelfEl = appEl.querySelector('.shelf');

    buildBoardDom();
    buildLevelDots();

    restartBtn.addEventListener('click', function(){ startLevel(0); });
    toolShuffleBtn.addEventListener('click', doShuffle);
    toolMineBtn.addEventListener('click', function(){ toggleTool('mine','mine'); });
    toolRowBtn.addEventListener('click', function(){ toggleTool('rowclear','rowclear'); });
    couponCopyBtn.addEventListener('click', function(){
      var reset = function(){ couponCopyBtn.textContent = 'Copy'; };
      if(navigator.clipboard && navigator.clipboard.writeText){
        var code = couponCodeEl ? couponCodeEl.textContent.trim() : 'CRYSTALPLAY';
        navigator.clipboard.writeText(code).then(function(){
          couponCopyBtn.textContent = 'Copied';
          setTimeout(reset, 1500);
        });
      }
    });

    startLevel(0);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
